import { useCallback, useEffect, useRef } from 'react'

function ConfirmationModal({ show, onHide, onConfirm }) {
  const triggerElementRef = useRef(null)

  // Store the element that triggered the modal when it opens
  useEffect(() => {
    if (show) {
      triggerElementRef.current = document.activeElement
    }
  }, [show])

  const handleHide = useCallback(() => {
    // Move focus away from any modal elements before hiding
    if (triggerElementRef.current && triggerElementRef.current.focus) {
      // Return focus to the element that opened the modal
      setTimeout(() => {
        triggerElementRef.current.focus()
        onHide()
      }, 10)
    } else {
      // Fallback: focus the document body
      setTimeout(() => {
        document.body.focus()
        onHide()
      }, 10)
    }
  }, [onHide])

  const handleConfirm = useCallback(() => {
    // Move focus away before confirming
    if (triggerElementRef.current && triggerElementRef.current.focus) {
      setTimeout(() => {
        triggerElementRef.current.focus()
        onConfirm()
        onHide()
      }, 10)
    } else {
      onConfirm()
      onHide()
    }
  }, [onConfirm, onHide])

  return (
    <div
      className={`modal fade ${show ? 'show' : ''}`}
      style={{ display: show ? 'block' : 'none' }}
      tabIndex="-1"
      aria-labelledby="confirmationModalLabel"
      aria-hidden={!show}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="confirmationModalLabel">
              Confirmation
            </h1>
            <button
              type="button"
              className="btn-close"
              onClick={handleHide}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <i className="bi bi-question-circle-fill"></i> Are you sure you want
            to apply these settings?
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleHide}
            >
              Cancel
            </button>            <button
              type="button"
              className="btn btn-primary"
              onClick={handleConfirm}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationModal
